/**
 * Fireball sprites: vanilla renders both fireballs as the fire_charge item
 * sprite, camera-facing and full-bright (large 1.0, small 0.5 block).
 */

import * as THREE from 'three';
import type { EnvUniforms } from './env';
import type { Fireball } from '../entities/nether/fireballs';
import { itemSpriteMesh } from './entities/extras';
import type { EntityMat } from './entities/core';

export class FireballRenderer {
  readonly group = new THREE.Group();
  private pool: Array<{ mesh: THREE.Mesh; mat: EntityMat }> = [];
  private live = new Map<number, { mesh: THREE.Mesh; mat: EntityMat }>();

  constructor(private readonly env: EnvUniforms) {}

  update(list: readonly Fireball[], alpha: number, camera: THREE.Camera): void {
    const seen = new Set<number>();
    for (const f of list) {
      seen.add(f.id);
      let s = this.live.get(f.id);
      if (!s) {
        s = this.pool.pop() ?? itemSpriteMesh(this.env, 'fire_charge', true);
        s.mat.uniforms.uLight.value = 1;
        this.group.add(s.mesh);
        this.live.set(f.id, s);
      }
      s.mesh.visible = true;
      s.mesh.position.set(f.px + (f.x - f.px) * alpha, f.py + (f.y - f.py) * alpha, f.pz + (f.z - f.pz) * alpha);
      s.mesh.quaternion.copy(camera.quaternion);
      s.mesh.scale.setScalar(f.small ? 0.5 : 1);
    }
    for (const [id, s] of this.live) {
      if (seen.has(id)) continue;
      s.mesh.visible = false;
      this.live.delete(id);
      this.pool.push(s);
    }
  }
}
